export default {
  header: String,
  plain: Boolean,
  backgroundColor: String
}


// WEBPACK FOOTER //
// ./src/components/Panel/_props.js